import BrandingService from '../../services/BrandingService';
import brandingUseCase from './brandingCase';

const brandingFactory = brandingUseCase({ BrandingService: BrandingService() });

export default brandingFactory;
